import React from "react";
import Layout from "../../layout/layout";
import HomeSeoForm from "./HomeSeoForm";
import SuccessModal from "../../components/halper/SuccessModal";
import ErrorModal from "../../components/halper/ErrorModal";
import LoaderModal from "../../components/halper/LoaderModal";
import addEditContainer from "./addEditContainer";

const AddHomeSeo = () => {
  const {
    homeSeo,
    handleChange,
    handleAction,
    closeModal,
    closeErrorModal,
    loader,
    editorRef,
    setSEOText,
    setHomeSeo,
    seoText,
  } = addEditContainer();

  return (
    <Layout>
      {homeSeo?.success ? (
        <SuccessModal message="Data Added Successfully!" onClick={closeModal} />
      ) : null}
      {homeSeo?.responseError ? (
        <ErrorModal message={homeSeo?.msg} onClick={closeErrorModal} />
      ) : null}

      <HomeSeoForm
        title="Add"
        handleChange={handleChange}
        setSEOText={setSEOText}
        setHomeSeo={setHomeSeo}
        homeSeo={homeSeo}
        onClick={handleAction}
        editorRef={editorRef}
        seoText={seoText}
        btnType="Save"
      />

      {loader ? <LoaderModal /> : null}
    </Layout>
  );
};

export default AddHomeSeo;
